/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData model module.
 * @module model/LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData
 * @version 1.0
 */
class LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData {
    /**
     * Constructs a new <code>LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData</code>.
     * @alias module:model/LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData
     */
    constructor() { 
        
        LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData} The populated <code>LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('hasHolder')) {
                obj['hasHolder'] = ApiClient.convertToType(data['hasHolder'], 'Boolean');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData.prototype['email'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData.prototype['nftUid'] = undefined;

/**
 * @member {Boolean} hasHolder
 */
LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData.prototype['hasHolder'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData;

